import { NavigationBar } from "../../../../components/navigation/NavigationBar";
import { ReactNode } from "react";
import { useIsDesktop } from "./useIsDesktop";
import { twMerge } from "tailwind-merge";
import { TwoPanelLayout } from "../../../../components/dashboard/TwoPanelLayout";

type CheckoutPageLayoutProps = {
  title: string;
  children: ReactNode;
  aside: ReactNode;
  alerts: ReactNode;
  layout?: "full" | "centered" | "single";
  onClickLeftIcon?: () => void;
  className?: string;
};
export const CheckoutPageLayout = ({
  title,
  children,
  aside,
  alerts,
  layout = "full",
  onClickLeftIcon,
  className,
}: CheckoutPageLayoutProps) => {
  const { isDesktop } = useIsDesktop();
  const isCentered = layout === "centered";

  const navigationBar = (
    <NavigationBar
      title={title}
      leftIcon="CHEVRON_LEFT"
      onClickLeftIcon={onClickLeftIcon}
    />
  );

  if (!isDesktop) {
    return (
      <>
        {navigationBar}
        <div
          className={twMerge(
            "flex min-h-[calc(100vh-var(--nav-height))] flex-1 flex-col gap-4 bg-white p-4",
            className,
          )}
        >
          {alerts}
          {aside}
          {children}
        </div>
      </>
    );
  }

  if (layout === "single") {
    return (
      <div className="flex min-h-full flex-col bg-white">
        {navigationBar}
        <div className="flex flex-1 justify-center bg-zinc-50 p-4">
          <div className="flex w-full max-w-[880px] flex-col gap-2">
            {alerts}
            <div className="h-full">{children}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <TwoPanelLayout
      firstPart="minmax(0, 1fr)"
      secondPart="min(33.333%, 640px)"
      secondClassName="border-l border-l-gray-300 bg-gray-100"
      first={
        <div className="flex min-h-full flex-col bg-white">
          {navigationBar}
          <div
            className={twMerge(
              "flex flex-1 p-4",
              isCentered && "justify-center",
            )}
          >
            <div
              className={twMerge(
                "flex w-full flex-col gap-2",
                isCentered && "max-w-[880px]",
              )}
            >
              {alerts}
              <div className="h-full">{children}</div>
            </div>
          </div>
        </div>
      }
      second={aside}
    />
  );
};
